angular.module('payments.components.paymentForm', [])
    .component('paymentForm', {
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&',
        },
        templateUrl: '/Scripts/app/payments/components/payment-form.template.html',
        controller: class PaymentFormCtrl {

            $interval: any;
            $window: any;
            $http: any;
            dismiss: any;
            resolve: any;

            provider: any;
            config: any;
            timeLeft: any;
            paymentFormSubmitted: boolean | undefined;
            paymentProviderEnum: any;

            timeRemaining: any;
            timeRemainingMins: any;
            timeRemainingSecs: any;
            timer: any = null;
            hasBookingTimedOut: boolean = false;

            static $inject = ['$interval', '$window', '$http'];

            constructor($interval: any, $window: any, $http: any) {
                this.$interval = $interval;
                this.$window = $window;
                this.$http = $http;
            }

            $onInit() {
                this.provider = this.resolve.provider;
                this.config = this.resolve.config;

                if (this.resolve.timeLeft) {
                    this.timeLeft = this.resolve.timeLeft;

                    this.timeRemaining = Date.now();
                    this.timeRemaining = moment.utc(this.timeRemaining).set('minute', this.timeLeft.mins);
                    this.timeRemaining = moment.utc(this.timeRemaining).set('second', this.timeLeft.secs);
                    this.timeRemainingMins = this.timeLeft.mins;
                    this.timeRemainingSecs = this.timeLeft.secs;

                    this.startTimer();
                }

                this.paymentFormSubmitted = false;
                this.paymentProviderEnum = this.$window.EveryBuddy.Enums.PaymentProvider;
            }

            startTimer = () => {
                if (this.timer == null) {
                    this.timer = this.$interval(() => {
                        this.timeRemaining = moment.utc(this.timeRemaining).subtract(1, 'second').toDate();

                        if (moment.utc(this.timeRemaining).get('minutes') == 0 &&
                            moment.utc(this.timeRemaining).get('seconds') == 0) {
                            this.hasBookingTimedOut = true;
                            this.timeRemainingMins = 0;
                            this.timeRemainingSecs = 0;
                            this.$interval.cancel(this.timer);
                            return;
                        }

                        this.timeRemainingMins = moment.utc(this.timeRemaining).get('minutes');
                        this.timeRemainingSecs = moment.utc(this.timeRemaining).get('seconds');
                    }, 1000);
                }
            };

            cancel = () => {
                this.dismiss({ paymentFormSubmitted: this.paymentFormSubmitted });
            }

            close = () => {
                this.close();
            }
        }
    });
